module.exports = __webpack_public_path__ + "static/media/zehnder.564f1805.png";